import { render, staticRenderFns } from "./PharmacyGroupFormComponent.vue?vue&type=template&id=31aa26a6"
import script from "./PharmacyGroupFormComponent.vue?vue&type=script&lang=js"
export * from "./PharmacyGroupFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports